import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Input,
  PageHeader,
  Checkbox,
  InputRadio,
} from "../../../../components/";
import { useHistory } from "react-router-dom";
import { CloseIcon, QuestionMark, SelectIcon } from "../../../../assets/";
import { useFormik } from "formik";
import { ExtrasValidator } from "./extrasValidator";
import {
  extrasHeaderWrapper,
  extrasSmallHeaderWrapper,
  extrasSmallHeader,
  extrasButtonElement,
  extrasMainWrapper,
  extrasButtonWrapper,
  closeIcon,
  extrasInputWrapper,
  extrasWrapper,
  agreeWrap,
  questionMark,
  extrasDisclaimer,
  extrasColor,
  markers,
  tooltip,
  tooltipClose,
} from "./extras.module.css";

const Extras = (props) => {
  const isEarlyBirdActive = false;
  const history = useHistory();
  const [hasCoupon, sethasCoupon] = useState(false);
  const [isStandard, setIsStandard] = useState(false);
  const [check, setCheck] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const { values, errors, handleChange, handleSubmit, setValues, touched } =
    useFormik({
      enableReinitialize: true,
      initialValues: {
        coupon: "",
        ...JSON.parse(sessionStorage.getItem("extras")),
      },
      validationSchema: ExtrasValidator,
      onSubmit: () => {
        var dataToPost = {
          category: selectedCategory,
          coupon: values.coupon,
        };
        sessionStorage.setItem("extras", JSON.stringify(values));
        props.onSubmit(dataToPost, hasCoupon);
        // props.onSubmit(dataToPost, hasCoupon);
      },
    });
  const gotoPrev = () => {
    setValues((values) => ({ ...values, values }));
    sessionStorage.setItem("extras", JSON.stringify(values));
    history.goBack();
  };
  const [tooltipText, setTooltipText] = useState(""); // State to hold the tooltip text

  const handleQuestionMarkClick = (title) => {
    setTooltipText(title);
  };

  const hideTooltip = () => {
    setTooltipText("");
  };

  const tooltipRef = useRef(null);

  const handleDocumentClick = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      hideTooltip();
    }
  };

  useEffect(() => {
    if (tooltipText) {
      document.addEventListener("click", handleDocumentClick);
    } else {
      document.removeEventListener("click", handleDocumentClick);
    }

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [tooltipText]);

  useEffect(() => {
    if (props && Object.keys(props.formData).length) {
      setValues(JSON.parse(JSON.stringify({ ...props.formData })));
    }
  }, [props, setValues]);

  return (
    <div className={extrasWrapper}>
      <div className={extrasMainWrapper}>
        <div className={extrasHeaderWrapper}>
          <PageHeader head="Payments" text="Make your payment" />
          <img
            className={closeIcon}
            src={CloseIcon}
            alt=""
            onClick={() => history.push("/")}
          />
        </div>

        <div className={extrasSmallHeaderWrapper}>
          <h5 className={extrasSmallHeader}>
            What category of applicants do you belong?
          </h5>
          <div className={extrasInputWrapper}>
            {isEarlyBirdActive ? (
              <div className={markers}>
                <InputRadio
                  type="radio"
                  checked={selectedCategory === "early-bird"}
                  onChange={() => {
                    setSelectedCategory("early-bird");
                    setIsStandard(false);
                    sethasCoupon(false);
                    setValues((prevValues) => ({ ...prevValues, coupon: "" }));
                  }}
                  name="early-bird"
                  radioText="Early Bird"
                />
              </div>
            ) : (
              <>
                <div className={markers}>
                  <InputRadio
                    type="radio"
                    checked={selectedCategory === "standard"}
                    onChange={() => {
                      setSelectedCategory("standard");
                      setIsStandard(true);
                      sethasCoupon(false);
                    }}
                    name="standard"
                    radioText="Standard"
                  />
                  <div
                    className={questionMark}
                    onClick={() =>
                      handleQuestionMarkClick(
                        "This category is for applicants who are registering through the normal process."
                      )
                    }
                  >
                    <QuestionMark />
                  </div>
                  {tooltipText && (
                    <div className={tooltip} ref={tooltipRef}>
                      {tooltipText}
                      <span className={tooltipClose} onClick={hideTooltip}>
                        &times;
                      </span>
                    </div>
                  )}
                </div>
                <div className={markers}>
                  <InputRadio
                    type="radio"
                    checked={selectedCategory === "up-skill"}
                    onChange={() => {
                      setSelectedCategory("up-skill");
                      setIsStandard(true);
                      sethasCoupon(false);
                      setValues((prevValues) => ({
                        ...prevValues,
                        coupon: "",
                      }));
                    }}
                    name="up-skill"
                    radioText="Genesys Pathway"
                  />
                  <div
                    className={`questionMark ${questionMark}`}
                    onClick={() =>
                      handleQuestionMarkClick(
                        "This category is for applicants who are currently part of the Genesys Pathway."
                      )
                    }
                  >
                    <QuestionMark />
                  </div>
                  {tooltipText && (
                    <div className={tooltip} ref={tooltipRef}>
                      {tooltipText}
                      <span className={tooltipClose} onClick={hideTooltip}>
                        &times;
                      </span>
                    </div>
                  )}
                </div>
                <div className={markers}>
                  <InputRadio
                    type="radio"
                    checked={selectedCategory === "nysc"}
                    onChange={() => {
                      setSelectedCategory("nysc");
                      setIsStandard(false);
                      sethasCoupon(false);
                      setValues((prevValues) => ({
                        ...prevValues,
                        coupon: "",
                      }));
                    }}
                    name="nysc"
                    radioText="NYSC"
                  />
                  <div
                    className={`questionMark ${questionMark}`}
                    onClick={() =>
                      handleQuestionMarkClick(
                        "This category is for applicants who are currently participating in the National Youth Service Corps (NYSC)."
                      )
                    }
                  >
                    <QuestionMark />
                  </div>
                  {tooltipText && (
                    <div className={tooltip} ref={tooltipRef}>
                      {tooltipText}
                      <span className={tooltipClose} onClick={hideTooltip}>
                        &times;
                      </span>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        <div>
          {selectedCategory === "up-skill" ? (
            <div className={extrasDisclaimer}>
              <p>
                <span className={extrasColor}>
                  Disclaimer(For Genesys Pathway Discount):{" "}
                </span>
                By selecting the Genesys Pathway discount option, you
                acknowledge that you participated and completed the Upskill 2025
                - Cohort 1, Upskill 2025 - Cohort 2 or the Learnable 24 program.
                Your eligibility for this discount will be automatically
                verified. If it is found that you are not eligible, there will
                be no refund, and you will be asked to pay the full application
                fee before joining Learnable 25.
              </p>
            </div>
          ) : null}
          {selectedCategory === "nysc" ? (
            <div className={extrasDisclaimer}>
              <p>
                <span className={extrasColor}>
                  Disclaimer(For the NYSC Discount):{" "}
                </span>
                By selecting the NYSC discount option, you acknowledge that you
                are actively serving (2025 Batch A, B or C). Your eligibility
                for this discount will be automatically verified. To ensure
                accurate verification, please use the same email address for
                registration that you used to register for NYSC. If it is found
                that you are not eligible, there will be no refund, and you will
                be asked to pay the full application fee before
                joining Learnable 25.
              </p>
            </div>
          ) : null}
          {isStandard ? (
            <h5 className={extrasSmallHeader}>Have a coupon code?</h5>
          ) : null}

          {isStandard ? (
            <div className={extrasInputWrapper}>
              <InputRadio
                type="radio"
                checked={hasCoupon === true}
                onChange={() => sethasCoupon(true)}
                name="Yes"
                radioText="Yes"
              />
              <InputRadio
                type="radio"
                checked={hasCoupon === false}
                onChange={() => {
                  sethasCoupon(false);
                  setValues((prevValues) => ({ ...prevValues, coupon: "" }));
                }}
                name="No"
                radioText="No"
              />
            </div>
          ) : null}

          {hasCoupon ? (
            <Input
              value={values.coupon}
              name="coupon"
              onChange={(e) => {
                handleChange(e);
              }}
              placeholder="Enter coupon code"
              errorText={errors.coupon}
            />
          ) : null}

          <div className={agreeWrap}>
            <p>
              By submiting this form, I confirm that the information provided is
              true, complete and accurate.
            </p>
            <div>
              <Checkbox
                type="checkbox"
                onChange={(e) => setCheck(e.target.checked)}
                checkboxLabel="Yes, I agree"
                id="agreed"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={extrasButtonWrapper}>
        <Button
          buttonName="Career path"
          className={extrasButtonElement}
          onClick={gotoPrev}
        />
        <Button
          main="fill"
          buttonName="Submit application 🚀"
          className={extrasButtonElement}
          onClick={handleSubmit}
          type="submit"
          disabled={!check ? true : false}
        />
      </div>
    </div>
  );
};
export { Extras };
